// Relevant to only the transaction history widget
export enum TransactionHistoryTopRightOption {
  TRANSACTION_TYPE_SELECTOR = 'TRANSACTION_TYPE_SELECTOR',
  QUICK_LINK = 'QUICK_LINK',
  HIDE = 'HIDE',
}
